import { styled } from '@mui/material/styles';
import { TableRow, TableCell, Box, Typography } from '@mui/material';

export const ProjectRow = styled(TableRow)(({ theme }) => ({
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transform: 'scale(1.01)',
    boxShadow: theme.shadows[4],
    cursor: 'pointer',
  },
}));

export const EmployeeRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
    transform: 'scale(1.01)',
    boxShadow: theme.shadows[2],
    cursor: 'pointer',
  },
  marginLeft: '30px',
}));

export const TaskRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transform: 'scale(1.01)',
    boxShadow: theme.shadows[1],
  },
}));

export const ProjectTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#e3f2fd',
  padding: '16px',
  whiteSpace: 'nowrap',
  borderLeft: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { borderLeft: 'none' },
}));

export const EmployeeTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#CDC1FF',
  padding: '12px 16px',
  whiteSpace: 'nowrap',
  borderLeft: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { borderLeft: 'none' },
}));

export const TaskTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#B9E5E8',
  padding: '12px 16px',
  whiteSpace: 'nowrap',
  borderLeft: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { borderLeft: 'none' },
}));

export const TaskDetailsCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  padding: '16px',
  borderLeft: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { borderLeft: 'none' },
}));

export const TaskDetailsBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
  marginLeft: theme.spacing(8),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

export const HeaderSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.7rem',
  color: theme.palette.text.secondary,
}));
